/* eslint-disable max-lines */
import {type Interpolation, type Theme} from '@mui/material';
import createTheme from '@mui/material/styles/createTheme';

import {commonPalette, darkPalette, lightPalette} from './constants';
import fontFaces from './fonts';

export let theme = createTheme({});
const getTheme = (mode: 'light' | 'dark') =>
  createTheme({
    direction: 'ltr',
    palette: {
      mode: mode,
      ...commonPalette,
      ...(mode === 'dark' ? darkPalette : lightPalette),
      grey1: theme.palette.augmentColor({
        color: {
          main: '#25272f',
          contrastText: '#fff',
        },
        name: 'grey1',
      }),
      black: theme.palette.augmentColor({
        color: {
          main: darkPalette.background?.default ?? '#000',
          contrastText: darkPalette.text?.secondary,
        },
        name: 'black',
      }),
    },
    shape: {borderRadius: 3.47},
    typography: {
      fontFamily: 'Geogrotesque Wide',
      htmlFontSize: 16,
      h1: {
        fontSize: '98px',
      },
      h2: {
        fontSize: '60px',
      },
      h3: {
        fontSize: '48px',
      },
      h4: {
        fontSize: '34px',
        lineHeight: '46.38px',
        fontWeight: 700,
      },
      h5: {
        fontSize: '24px',
        fontWeight: 'bold',
      },
      h6: {
        fontSize: '20px',
        fontWeight: 600,
        lineHeight: '24.55px',
      },
      subtitle1: {
        fontSize: '16px',
      },
      subtitle2: {
        fontSize: '14px',
      },
      body1: {
        fontSize: '16px',
        lineHeight: '21.82px',
        fontWeight: 400,
      },
      body2: {
        fontSize: '14px',
      },
      button: {
        fontSize: '15px',
        fontWeight: 600,
        lineHeightStep: '20.46px',
      },
      caption: {
        fontSize: '12px',
        lineHeight: '16.37px',
        fontWeight: 400,
      },
      overline: {
        fontSize: '10px',
        fontWeight: 'bold',
        lineHeight: '11px',
      },
    },
    components: {
      MuiDrawer: {
        styleOverrides: {
          paper: {
            scrollbarWidth: 'none',
            '&::-webkit-scrollbar': {
              display: 'none',
            },
            overflowY: 'auto',
            WebkitOverflowScrolling: 'touch',
          },
        },
      },
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true,
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: 'none !important',
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          root: {
            border: 'none',
            outline: 'none',
            '&::after , &::before , &:hover:before': {
              border: 'none !important',
              outline: 'none',
            },
          },
          input: {
            border: 'none',
            outline: 'none',
          },
        },
      },
      MuiCssBaseline: {
        styleOverrides: `${fontFaces}`,
      },
      MuiBackdrop: {
        styleOverrides: {
          root: {
            backdropFilter: 'blur(4px)',
            backgroundColor: 'rgba(24, 26, 32, 0.4)',
          },
        },
      },
    },
  });

theme = getTheme('dark');
//
export const globalStyles: Interpolation<Theme> = {
  html: {
    overflowX: 'hidden',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  body: {
    margin: '0 auto' + ' !important',
    overflowX: 'hidden',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    padding: 0,
    fontFamily: 'Geogrotesque Wide',
    maxWidth: '768px',
    height: '100%',
    minHeight: '100vh',
    background:
      'radial-gradient(92.77% 33.98% at 49.11% 1.76%, #181A20 16.5%, #202229 100%)',
  },
  'div#root': {
    height: '100%',
  },
  '.hide-scrollbar': {
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  '*': {
    borderRadius: theme.shape.borderRadius,
  },
};
